'use strict';

const eventEmitter = require('ev-emitter');

const events = new eventEmitter();

if (isDevelopment) {
    const called = 'Event called: ';
    /**
     * Событие на смену местоположения
     *
     * @param data
     * @param data.id Код местоположения (Bitrix Местоположения 2.0)
     * @param data.name Название местоположения
     * @param data.element Node текущего элемента
     */
    events.on('setLocation', data => {
        console.log(called + 'setLocation, ', data);
    });
}

export default events;



// WEBPACK FOOTER //
// ./modules/events.js